import React from "react";
import "./AudioCallPopups.css";
import { FaPhone } from "react-icons/fa6";

const ReceivedAudioCallPopups = ({
    visible,
    callerName = "Incoming Call",
    onAccept,
    onReject,
}) => {
    if (!visible) return null;

    return (
        <div className="audio-call-overlay">
            <div className="audio-call-card incoming">
                <div className="audio-call-avatar">
                    <FaPhone style={{ fontSize: 26 }} />
                </div>
                <h3>Incoming Audio Call</h3>
                <p>{callerName}</p>

                <div className="audio-call-actions two">
                    <button className="audio-btn reject" onClick={onReject}>
                        Reject
                    </button>
                    <button className="audio-btn accept" onClick={onAccept}>
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReceivedAudioCallPopups;